import React, { useState, useEffect, useLayoutEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { config } from "./pages/Test/config";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/index.css";
import { Button } from "@aws-amplify/ui-react";

import Test from "./pages/Test/Test";
import Managerment from "./pages/Test/Management";
import ContactMe from "./pages/ContactMe/ContactMe";
import Onsite from "./pages/Test/Onsite";
import Navbars from "./components/Nav";
import Auth from "./pages/Login/Auth";
import Report from "./pages/Test/Report";

// import LoginComponent from "./pages/Login/login-component";

const EntryPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "25vh",
        gap: "20px",
      }}
    >
      <h1>李如浩醫師兒童成長發育門診</h1>
      <h2 style={{ color: "gray" }}>請選擇診所</h2>
      <div
        style={{
          display: "flex",
          // flexDirection: "column",
          gap: "5vw",
          width: "70vw",
          height: "30vh",
        }}
      >
        <Button
          onClick={() => navigate("/hansheng")}
          style={{
            backgroundColor: "#A8D8B9",
            border: "none",
            color: "black",
            padding: "10px 20px",
            fontSize: "1.6em",
            width: "100%",
          }}
        >
          <>
            <div style={{ textAlign: "center" }}>
              菡生
              <br />
              婦幼診所
              <span
                style={{ color: "gray", display: "block", fontSize: "0.8em" }}
              >
                板橋
              </span>
            </div>
          </>
        </Button>
        <Button
          onClick={() => navigate("/yoyo")}
          style={{
            backgroundColor: "#F4A7B9",
            border: "none",
            color: "black",
            padding: "10px 20px",
            fontSize: "1.6em",
            width: "100%",
          }}
        >
          <>
            <div style={{ textAlign: "center" }}>
              宥宥
              <br />
              婦幼診所
              <span
                style={{ color: "gray", display: "block", fontSize: "0.8em" }}
              >
                蘆洲
              </span>
            </div>
          </>
        </Button>
      </div>
    </div>
  );
};

const App = () => {
  const [user, setUser] = useState(null);
  const [clinicName, setClinicName] = useState(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    console.log(config.gettodayymd());
    if (userData && userData.createTime) {
      const createDate = userData.createTime.split("-").slice(0, 3).join("-");
      console.log("createDate", createDate);
      if (createDate === config.gettodayymd()) {
        setUser(userData);
        setClinicName(userData.clinic);
      } else {
        localStorage.removeItem("userData");
        setUser(null);
        setClinicName(null);
        // navigate("/");
      }
    } else {
      localStorage.removeItem("userData");
      setUser(null);
      setClinicName(null);
      // navigate("/");
    }
  }, []); // 空数组作为依赖项，确保只在组件挂载时执行一次

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const navigate = useNavigate(); // 現在可以使用 useNavigate

  const signOut = () => {
    setUser(null);
    setClinicName(null);
    localStorage.removeItem("userData");
    navigate("/");
  };

  const signIn = async (userData) => {
    setUser(userData);
    setClinicName(userData.clinic);
    userData.createTime = await config.getTaipeiTimeString();
    // 从用户数据中删除密码
    delete userData.password;
    localStorage.setItem("userData", JSON.stringify(userData));
    navigate("/management");
  };
  useLayoutEffect(() => {
    // 这个函数会在每次渲染后立即同步调用
    window.addEventListener("error", (e) => {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {user && <Navbars signOut={signOut} user={user?.account} />}
      <Routes>
        <Route path="/EntryPage" element={<EntryPage />} />

        <Route path="/hansheng" element={<Test user={user} />} />
        <Route path="/yoyo" element={<Test user={user} />} />
        <Route path="/onsite" element={<Onsite />} />
        <Route path="/Contact_Me" element={<ContactMe />} />
        <Route
          path="/management"
          element={
            <Managerment
              user={user}
              setUser={setUser}
              clinicName={clinicName}
              setClinicName={setClinicName}
            />
          }
        />
        <Route path="/report" element={<Report user={user} />} />
        <Route
          path="/"
          element={
            <div
              style={{
                width: "100vw",
                height: "100vh",
                margin: "0 auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Auth signIn={signIn} />
            </div>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
